import { MimeType } from "@/components/upload/constants"
import { FieldGroupEnum } from "@/graphql/codegen/graphql"
import colors from "@/styles/colors"

export const COMPANY_INFO_TEXT_AREA_MAX_SIZE = 2048
export const COMPANY_INFO_TEXT_AREA_ERROR_MESSAGE = `Maximum length is ${COMPANY_INFO_TEXT_AREA_MAX_SIZE} characters.`

export const CompanyFileTypeMap: Record<CompanyInfoFileType, { label: string; color: string }> = {
  [FieldGroupEnum.Brochure]: {
    label: "Brochure",
    color: colors.tertiary.yellow["300"],
  },
  [FieldGroupEnum.Miscellaneous]: {
    label: "Miscellaneous",
    color: colors.tertiary.purple["100"],
  },
  [FieldGroupEnum.TechnicalData]: {
    label: "Technical Data",
    color: colors.primary["200"],
  },
}

export const ALLOWED_FILE_FORMATS = [
  MimeType.IMAGE_JPG,
  MimeType.IMAGE_JPEG,
  MimeType.IMAGE_PNG,
  MimeType.PDF,
  MimeType.DOC,
  MimeType.DOCX,
]

export type CompanyInfoFileType = FieldGroupEnum.Brochure | FieldGroupEnum.Miscellaneous | FieldGroupEnum.TechnicalData
